const PharmacyGroups = {
    namespaced: true,
    state: {
        id: null,
        pharmacy_group: {
            group_name: null,
            is_registered: false,
            name: null,
            address: null,
            post_code: null,
            phone: null,
            fax: null,
            email: null,
            blood_providers: null,
            chief_pharmacist_name: null,
            chief_pharmacist_phone: null,
            chief_pharmacist_fax: null,
            chief_pharmacist_email: null,
            chief_pharmacist_rpsgb_number: null,
            technician_name: null,
            technician_phone: null,
            technician_fax: null,
            technician_email: null,
            technician_rpsgb_number: null,
            out_of_hours_contact_name: null,
            out_of_hours_contact_phone: null,
            out_of_hours_contact_fax: null,
            out_of_hours_contact_email: null,
            pharmacy_sites: [],
            blood_result_providers: [],
        },
        pharmacy_groupSnapShot: {
            group_name: null,
            is_registered: false,
            name: null,
            address: null,
            post_code: null,
            phone: null,
            fax: null,
            email: null,
            blood_providers: null,
            chief_pharmacist_name: null,
            chief_pharmacist_phone: null,
            chief_pharmacist_fax: null,
            chief_pharmacist_email: null,
            chief_pharmacist_rpsgb_number: null,
            technician_name: null,
            technician_phone: null,
            technician_fax: null,
            technician_email: null,
            technician_rpsgb_number: null,
            out_of_hours_contact_name: null,
            out_of_hours_contact_phone: null,
            out_of_hours_contact_fax: null,
            out_of_hours_contact_email: null,
            pharmacy_sites: [],
            blood_result_providers: [],
        },
        errorMessages: {
            pharmacy_group: {
                group_name: [],
                is_registered: [],
                address: [],
                post_code: [],
                phone: [],
                fax: [],
                email: [],
                pharmacy_sites: [],
                blood_providers: [],
                chief_pharmacist_name: [],
                chief_pharmacist_phone: [],
                chief_pharmacist_fax: [],
                chief_pharmacist_email: [],
                chief_pharmacist_rpsgb_number: [],
                technician_name: [],
                technician_phone: [],
                technician_fax: [],
                technician_email: [],
                technician_rpsgb_number: [],
                out_of_hours_contact_name: [],
                out_of_hours_contact_phone: [],
                out_of_hours_contact_fax: [],
                out_of_hours_contact_email: [],
                blood_result_providers: [],
            },
        },
        pharmacyGroupOptions: [],
        pharmacyGroupsOptions: [],
        bloodProvidersOptions: [],
        updatedProps: [],
    },
    mutations: {
        SET_PROPERTY(state, data) {
            state[data.property] = data.value;
        },
        SET_PHARMACY_GROUP(state, pharmacyGroup) {
            state.pharmacy_group = pharmacyGroup;
        },
        SET_PHARMACY_GROUP_SNAP_SHOT(state, data) {
            state.pharmacy_groupSnapShot = data;
        },
        SET_PHARMACY_GROUP_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            // state.patient[data.property] = data.value;
        },
        SET_PHARMACY_GROUP_OPTIONS(state, data) {
            state.pharmacyGroupOptions = data;
        },
        SET_BLOOD_PROVIDERS_OPTIONS(state, data) {
            state.bloodProvidersOptions = data;
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // _.set(state, data.property, data.value);
        },
        RESET_PHARMACY_GROUP(state) {
            state.pharmacy_group = {
                group_name: null,
                is_registered: false,
                name: null,
                address: null,
                post_code: null,
                phone: null,
                fax: null,
                email: null,
                blood_providers: null,
                chief_pharmacist_name: null,
                chief_pharmacist_phone: null,
                chief_pharmacist_fax: null,
                chief_pharmacist_email: null,
                chief_pharmacist_rpsgb_number: null,
                technician_name: null,
                technician_phone: null,
                technician_fax: null,
                technician_email: null,
                technician_rpsgb_number: null,
                out_of_hours_contact_name: null,
                out_of_hours_contact_phone: null,
                out_of_hours_contact_fax: null,
                out_of_hours_contact_email: null,
                pharmacy_sites: [],
                blood_result_providers: [],
            };
        },
        SET_UPDATED_PROPS(state, props) {
            state.updatedProps = props;
        },
        SET_PHARMACY_GROUPS_OPTIONS(state, data) {
            state.pharmacyGroupsOptions = data;
        },
    },
    actions: {
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        loadPharmacyGroupSnapShot({ commit }, data) {
            commit('SET_PHARMACY_GROUP_SNAP_SHOT', data);
        },
        loadPharmacySite({ commit }, data) {
            for (let property of Object.keys(data)) {
                commit('SET_PROPERTY', { property, value: data[property] });
            }
        },
        loadPharmacyOptions({ commit }, filters = null) {
            axios
                .get(
                    route('api.v1.pharmacy-sites.options', {
                        sort: 'name',
                        site_name: filters && filters.site_name ? filters.site_name : null,
                        dms_id: filters && filters.dms_id ? filters.dms_id : null,
                        registered: filters && filters.registered ? filters.registered : null,
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACY_GROUP_OPTIONS', data);
                });
        },
        updateProperty({ commit }, data) {
            commit('SET_PHARMACY_GROUP_PROPERTY', data);
        },
        loadPharmacyGroup({ commit }, data) {
            commit('SET_PHARMACY_GROUP', data);
            // for (let property of Object.keys(data)) {
            //     commit('SET_PATIENT_PROPERTY', { property, value: data[property] });
            // }
        },
        async loadPharmacyGroupsOptions({ commit }) {
            return await axios
                .get(
                    route('api.v1.pharmacy-groups.options', {
                        sort: 'name',
                    })
                )
                .then((response) => {
                    const data = response.data.data;
                    commit('SET_PHARMACY_GROUPS_OPTIONS', data);
                });
        },
        resetPharmacyGroup({ commit }) {
            commit('RESET_PHARMACY_GROUP');
        },
        resetErrorMessages({ commit, state }) {
            _.each(state.errorMessages, function (messages, field) {
                const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
                if (_.isPlainObject(vueObjectToPlain)) {
                    _.each(state.errorMessages[field], function (messages, plainObjectField) {
                        commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
                    });
                } else {
                    commit('SET_ERROR_MESSAGE', { value: [], property: field });
                }
            });
        },
        setErrorMessages({ commit, state }, errors) {
            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages.pharmacy_group, fieldErrors.field);

                if (fieldErrors.field && errorMessageField !== undefined) {
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: 'pharmacy_group.' + fieldErrors.field,
                    });
                }
            });
        },
    },
};

export default PharmacyGroups;
